import React from "react";
import CustomModal from "../../../assets/components/ModalComonent";
import classes from "./style.module.css";
import CheckImg from "../../../assets/images/common/checkVector.svg";

export default function PhoenesDialog({ show, handleClose }) {
  const phonesContent = (
    <div className="w-100 text-center">
      <img src={CheckImg} alt="check-vector" className={classes.alertBanner} />
      <p className={classes.smallTitle}>{`شماره تلفن روابط عمومی (داخلی)`}</p>
      <div className={classes.dialogContent}>
        <div className="text-center">
          <p>۳۵۱۵۱</p>
          <p>۳۳۶۸۳</p>
          <p>۳۳۶۲۳</p>
          <p>۳۳۳۲۷</p>
        </div>
      </div>
    </div>
  );
  return (
    <CustomModal
      open={show}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={phonesContent}
    />
  );
}
